module.exports = __webpack_public_path__ + "static/flyover-1-19-a5bc9d6258f978da20c102317d9d021c.jpeg";